import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-176c64b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gameDetailForm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl" }, "Game Details", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "py-5 text-gray-text" }, " In addition to inputting your primary game details, you can also choose to either have your gamers play your game for free or sell your game for a certain amount of XAR and once your game publisher is verified, the game publisher will be displayed with a blue check beside it. ", -1))
const _hoisted_4 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Game ID", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group md:flex mb-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Price"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control text-white border-0",
      placeholder: "0.00",
      disabled: ""
    })
  ])
], -1))
const _hoisted_8 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Content Rating", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "General" }, "General", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "M18" }, "M18", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Genre", -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<option value=\"Action\" data-v-176c64b4>Action</option><option value=\"Adventure\" data-v-176c64b4>Adventure</option><option value=\"Role-Playing\" data-v-176c64b4>Role-Playing</option><option value=\"Simulation\" data-v-176c64b4>Simulation</option><option value=\"Strategy\" data-v-176c64b4>Strategy</option><option value=\"Puzzle\" data-v-176c64b4>Puzzle</option><option value=\"Idle\" data-v-176c64b4>Idle</option><option value=\"Action role-playing game\" data-v-176c64b4>Action role-playing game</option><option value=\"Turn-based strategy\" data-v-176c64b4>Turn-based strategy</option><option value=\"Real-time strategy\" data-v-176c64b4>Real-time strategy</option><option value=\"First-person-shooter\" data-v-176c64b4>First-person-shooter</option><option value=\"Visual Novel\" data-v-176c64b4>Visual Novel</option><option value=\"Massively multiplayer online role-playing game\" data-v-176c64b4>Massively multiplayer online role-playing game</option>", 13)
const _hoisted_28 = [
  _hoisted_15
]
const _hoisted_29 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Tags", -1))
const _hoisted_31 = { class: "form-control text-white border-0" }
const _hoisted_32 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Language", -1))
const _hoisted_34 = { class: "language-table table-auto text-white border-black-border border p-1 w-full" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-black-border border-b text-gray-text p-3" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Audio"),
    /*#__PURE__*/_createElementVNode("th", null, "Interface"),
    /*#__PURE__*/_createElementVNode("th", null, "Subtitles")
  ])
], -1))
const _hoisted_36 = { class: "border-black-border" }
const _hoisted_37 = ["onUpdate:modelValue", "onInput"]
const _hoisted_38 = ["onUpdate:modelValue", "onInput"]
const _hoisted_39 = ["onUpdate:modelValue", "onInput"]
const _hoisted_40 = {
  key: 0,
  class: "border-black-border border-b"
}
const _hoisted_41 = {
  scope: "row",
  colspan: "3"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_45 = { class: "py-5" }
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tags_input = _resolveComponent("tags-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, [
          _createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            placeholder: "First name",
            value: _ctx.gameData.game.gameId,
            disabled: ""
          }, null, 8, _hoisted_6)
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control text-white border-0",
            "aria-label": "Default select example",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.details.ContentRating) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputHasChanged(_ctx.details.ContentRating, _ctx.gameData.game.contentRating)))
          }, _hoisted_12, 544), [
            [_vModelSelect, _ctx.details.ContentRating]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control text-white border-0",
            "aria-label": "Default select example",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.details.Category) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputHasChanged(_ctx.details.Category, _ctx.gameData.game.category)))
          }, _hoisted_28, 544), [
            [_vModelSelect, _ctx.details.Category]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_tags_input, {
            "element-id": "tags",
            class: "bg-xr-body text-white",
            style: {"border-radius":"4px"},
            modelValue: _ctx.selectedTags,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTags) = $event)),
            "existing-tags": _ctx.existingTags,
            typeahead: true,
            onTagAdded: _ctx.onTagAdded,
            onTagRemoved: _ctx.onTagRemoved
          }, null, 8, ["modelValue", "existing-tags", "onTagAdded", "onTagRemoved"])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", null, [
          _createElementVNode("table", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("tbody", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "border-black-border border-b",
                  key: row.name
                }, [
                  _createElementVNode("td", null, _toDisplayString(row.name), 1),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "audio",
                      value: "row.audio",
                      "onUpdate:modelValue": ($event: any) => ((row.audio) = $event),
                      onInput: ($event: any) => (_ctx.inputHasChanged(row.audio, !row.audio))
                    }, null, 40, _hoisted_37), [
                      [_vModelCheckbox, row.audio]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "interface",
                      value: "row.interface",
                      "onUpdate:modelValue": ($event: any) => ((row.interface) = $event),
                      onInput: ($event: any) => (_ctx.inputHasChanged(row.interface, !row.interface))
                    }, null, 40, _hoisted_38), [
                      [_vModelCheckbox, row.interface]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "subtitles",
                      value: "row.subtitles",
                      "onUpdate:modelValue": ($event: any) => ((row.subtitles) = $event),
                      onInput: ($event: any) => (_ctx.inputHasChanged(row.subtitles, !row.subtitles))
                    }, null, 40, _hoisted_39), [
                      [_vModelCheckbox, row.subtitles]
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.viewrow == true)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-control text-white border-0",
                        style: {"width":"150px"},
                        "aria-label": "Default select example",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.language) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.name
                          }, _toDisplayString(item.name), 1))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.language]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "audio",
                        value: "audio",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.audio) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.audio]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "languageInterface",
                        value: "languageInterface",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.languageInterface) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.languageInterface]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "subtitles",
                        value: "subtitles",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.subtitles) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.subtitles]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_41, [
                  _createElementVNode("button", {
                    class: "rounded-md bg-black-primary px-3 text-md py-2 text-white",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.viewrow = true; _ctx.hasChanged = true;})
                  }, "Add New Language")
                ]),
                _hoisted_42,
                _hoisted_43,
                _hoisted_44
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary px-5",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateGameDetails && _ctx.updateGameDetails(...args))),
        disabled: !_ctx.hasChanged
      }, "Save", 8, _hoisted_46)
    ])
  ], 64))
}